import { useCallback, useState } from 'react';
import { AuthFailure, ResourceState, SectionHeading, useResource } from './shared';
import { PaymentSettings, PaymentSettingsForm } from './SellerPaymentSettings';
import './Finance.css';

interface PgSettings extends PaymentSettings {
  configured: boolean;
}
export function PgSettingsView({ onAuth }: { onAuth: AuthFailure }) {
  const state = useResource<PgSettings>('/pg-settings', onAuth), [saved, setSaved] = useState(false);
  const onBusy = useCallback(() => {}, []);
  return <div className="pa-finance">
    <ResourceState {...state} retry={state.reload}>{state.data && <>
      {saved && <p className="pa-success" role="status">본사 PG 설정을 저장했습니다.</p>}
      <section className="pa-card"><SectionHeading title="본사 헥토 계약" description="본사가 결제대금을 수령하고 셀러에게 정산합니다. 본사 공통 사용으로 설정된 셀러에 적용됩니다. 셀러별 실제 계약은 셀러 결제 설정에서 전환할 수 있습니다." />
        <PaymentSettingsForm key={state.data.revision} seq={0} settings={state.data} endpoint="/pg-settings" headquarters onAuth={onAuth} onBusy={onBusy}
          reload={state.reload} saved={() => { setSaved(true); state.reload(); }} />
      </section>
    </>}</ResourceState>
  </div>;
}
